import { CalendarIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';
import type { BusinessVisitDto } from '@/lib/api/jobs';

import { formatDate, statusColorClass, visitStatusLabel } from '../jobs/helpers';

interface Props {
  visit: BusinessVisitDto;
  onSelect: (visit: BusinessVisitDto) => void;
}

export function VisitListItem({ visit, onSelect }: Props) {
  const { t } = useLanguage();

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(visit)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onSelect(visit);
      }}
      className="bg-card border rounded-xl p-4 flex items-center justify-between gap-3 hover:shadow-sm transition-shadow cursor-pointer"
      data-testid={`schedule-visit-${visit.id}`}
    >
      <div className="min-w-0 flex flex-col gap-1">
        <h3 className="font-semibold text-sm truncate">{visit.job_title}</h3>
        <p className="text-xs text-muted-foreground flex items-center gap-1.5">
          <CalendarIcon className="w-3.5 h-3.5 shrink-0" />
          {formatDate(visit.scheduled_date)}
        </p>
      </div>
      <span
        className={`text-[11px] font-medium px-2 py-0.5 rounded-full shrink-0 ${statusColorClass(
          visit.status,
        )}`}
      >
        {visitStatusLabel(visit.status, t)}
      </span>
    </div>
  );
}
